import { del, get, set } from "idb-keyval";

/**
 * Creates an Indexed DB Storage
 * @see https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */
export function createIDBStorage() {
  return {
    getItem: async (key: string) => {
      return await get(key);
    },
    setItem: async (key: string, value: any) => {
      await set(key, value);
    },
    removeItem: async (key: string) => {
      await del(key);
    },
  };
}
